var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "observer",
    attrs: { tag: "form" },
    on: {
      submit: function ($event) {
        $event.preventDefault()
        return _vm.submit.apply(null, arguments)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ valid }) {
          return [
            _c(
              "div",
              { staticClass: "modal-card", staticStyle: { width: "auto" } },
              [
                _c("header", { staticClass: "modal-card-head" }, [
                  _c("p", { staticClass: "modal-card-title" }, [
                    _vm._v(" Edit device. "),
                  ]),
                ]),
                _c(
                  "section",
                  {
                    staticClass: "modal-card-body",
                    staticStyle: { "min-height": "70vh" },
                  },
                  [
                    _c(
                      "b-field",
                      { attrs: { label: "Plant" } },
                      [
                        _c("multiselect", {
                          attrs: {
                            options: _vm.$lodash.orderBy(_vm.plants, ["name"]),
                            multiple: false,
                            "close-on-select": true,
                            placeholder: "Pick plant...",
                            "custom-label": _vm.getLabel,
                            "track-by": "id",
                          },
                          model: {
                            value: _vm.selectedPlant,
                            callback: function ($$v) {
                              _vm.selectedPlant = $$v
                            },
                            expression: "selectedPlant",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      { attrs: { label: "Customer" } },
                      [
                        _c("multiselect", {
                          attrs: {
                            options: _vm.customers,
                            multiple: false,
                            "close-on-select": true,
                            placeholder: "Pick customer...",
                            "custom-label": _vm.getLabel,
                            "track-by": "id",
                          },
                          model: {
                            value: _vm.selectedCustomer,
                            callback: function ($$v) {
                              _vm.selectedCustomer = $$v
                            },
                            expression: "selectedCustomer",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      { attrs: { label: "Producer" } },
                      [
                        _c("multiselect", {
                          attrs: {
                            options: _vm.$lodash.orderBy(_vm.plants, ["name"]),
                            multiple: false,
                            "close-on-select": true,
                            placeholder: "Pick producer...",
                            "custom-label": _vm.getLabel,
                            "track-by": "id",
                          },
                          model: {
                            value: _vm.selectedProducer,
                            callback: function ($$v) {
                              _vm.selectedProducer = $$v
                            },
                            expression: "selectedProducer",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      { attrs: { label: "Serial Number" } },
                      [
                        _c("ValidationProvider", {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("b-input", {
                                      attrs: {
                                        name: "serialnumber",
                                        type: "text",
                                        required: "",
                                      },
                                      model: {
                                        value: _vm.newDevice.serialNumber,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.newDevice,
                                            "serialNumber",
                                            $$v
                                          )
                                        },
                                        expression: "newDevice.serialNumber",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm.newDevice.registrationCode
                      ? _c(
                          "div",
                          [
                            _c(
                              "b-field",
                              { attrs: { label: "Registration code" } },
                              [
                                _c("b-input", {
                                  attrs: {
                                    name: "registrationCode",
                                    type: "text",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.newDevice.registrationCode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.newDevice,
                                        "registrationCode",
                                        $$v
                                      )
                                    },
                                    expression: "newDevice.registrationCode",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("canvas", {
                              staticClass: "block",
                              attrs: { id: "qrcode" },
                            }),
                            _c("b-button", {
                              attrs: { "icon-left": "download" },
                              on: { click: _vm.downloadQRCode },
                            }),
                            _c("p", [
                              _vm._v("Device registration code: "),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.newDevice.registrationCode)),
                              ]),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.selectedCustomer
                      ? [
                          _c("hr"),
                          _c("p", { staticClass: "title is-6" }, [
                            _vm._v(" Device Configuration "),
                          ]),
                          _c(
                            "b-field",
                            { attrs: { label: "Reference Required" } },
                            [
                              _c("b-switch", {
                                model: {
                                  value: _vm.deviceConfig.referenceRequired,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.deviceConfig,
                                      "referenceRequired",
                                      $$v
                                    )
                                  },
                                  expression: "deviceConfig.referenceRequired",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Auto Sync" } },
                            [
                              _c("b-switch", {
                                model: {
                                  value: _vm.deviceConfig.autoSyncEnabled,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.deviceConfig,
                                      "autoSyncEnabled",
                                      $$v
                                    )
                                  },
                                  expression: "deviceConfig.autoSyncEnabled",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Allowed Movement Types" } },
                            [
                              _c(
                                "div",
                                { staticClass: "buttons" },
                                _vm._l(_vm.mvtTypes, function (mvt) {
                                  return _c(
                                    "b-checkbox-button",
                                    {
                                      key: mvt.code,
                                      attrs: {
                                        "native-value": mvt.code,
                                        type: "is-info",
                                      },
                                      model: {
                                        value: _vm.deviceConfig.allowedMvt,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.deviceConfig,
                                            "allowedMvt",
                                            $$v
                                          )
                                        },
                                        expression: "deviceConfig.allowedMvt",
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(mvt.code) + " ")]
                                  )
                                }),
                                1
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _c("footer", { staticClass: "modal-card-foot" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-info is-fullwidth",
                      class: { "is-loading": _vm.isSubmitting },
                      attrs: { type: "submit" },
                    },
                    [_vm._v(" Submit ")]
                  ),
                ]),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }